import React, { useState } from "react";

interface Props {
  originalName: string;
  onRename: (newName: string) => void;
  onCancel: () => void;
}

function RenameTab({ originalName, onRename, onCancel }: Props) {
  const [newName, setNewName] = useState(originalName);

  return (
    <>
      <input
        className="tab-text"
        style={{
          whiteSpace: "nowrap",
          backgroundColor: "transparent",
          color: "#ffffff",
          outline: "none",
          outlineWidth: 0,
          borderWidth: 0,
          width: "100%",
          minWidth: 200,
        }}
        placeholder={"Enter new tab name"}
        autoFocus
        value={newName}
        onChange={(e) => {
          // new tab name should be less than 40 characters and alphanumeric
          if (e.target.value.length <= 40)
            setNewName(e.target.value.replace(/[^a-zA-Z\d ]/gi, ""));
        }}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            onCancel();
          } else if (e.key === "Enter") {
            onRename(newName);
          }
        }}
        onBlur={() => onRename(newName)}
      />
    </>
  );
}
export default React.memo(RenameTab);
